import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faBars, faX } from '@fortawesome/free-solid-svg-icons';

import {goToLocation, fnDrawerMenu } from 'assets/js/commonUtil';
import { useEffect, useState } from "react";

export default function Header() {

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isFix, setIsFix] = useState(false);

  const handleMovePage = ({ item }: { item: { url: string; type: string } }) => {
    navigate(`${item.url}`, {
      state: {
        type: `${item.type}`,
      },
    });
  };

  async function fetchData() {
    if(pathname == "/"){
      setIsFix(true);
    }else{
      setIsFix(false);
    }
  }
  
  useEffect(() => {  
    fetchData();
  }, []);

  return (
    <div className="common-wrapper top-wrap fix" style={{lineHeight:0, position:"relative"}}>
      {/*
      <div className="top-section flex flex-justfy-content-center align-items-center" >
        <div style={{ flex: 1 }} className="flex flex-justfy-content-center align-items-center">
          <img src="https://img.chunhomall.com/images/ikeyssuk/w_img_call.gif" style={{width:"100%"}} alt=""/>
        </div>
        <div style={{ flex: 1 }} className="flex flex-justfy-content-center align-items-center">
         
        </div>
        <div style={{ flex: 1 }} className="flex flex-justfy-content-center align-items-center">
          <img src="https://img.chunhomall.com/images/ikeyssuk/w_img_btn.gif" style={{width:"100%"}} alt=""/>
        </div>
      </div>
      */}
      
      <img src="https://img.chunhomall.com/images/chunsimbon/MO_main_2508_01.jpg" alt="침향천진단" style={{width:'100%'}} />
      <a onClick={(e) => window.scrollBy({top: document.querySelector("#apply-list")?.getBoundingClientRect().top, behavior: "smooth"}) } style={{position:"absolute", top:"0px", right:"0px", height:"100%", width:"35vw"}}>&nbsp;</a>
      
      
    </div>
  );
}